export default __webpack_public_path__ + "static/181-6ecc43a1e3583e1fdd1062416c95befe.jpg";